export const routeMap = {
  '/project/detail': '项目详情',
  '/pdfview': '文件预览',
  '/': '首页',
  '/search': '搜索',
  '/login': '登录',
  '/kp/seed/detail': '部门公客池-详情',
  '/project/meetingAudio': '会议录音',
  '/finance/middlePage/detail': '北冥-财务交易数据中间页',
  '/project': '项目列表',
  '/pdfview/template': '文件预览-template',
  '/pdfview/finish': '文件预览-finish',
  '/finance': '北冥-首页',
  '/systemSetting/manage/rolePower/data': '设置-用户管理-角色权限管理-数据权限',
  '/meeting/list': '已排会',
  '/person': '个人管理-基本信息',
  '/systemSetting/manage/projectQuality': '设置-项目管理-品质表',
  '/systemSetting/info/trace': '设置-我的追踪',
  '/systemSetting/manage/rolePower/menu': '设置-用户管理-角色权限管理-菜单权限',
  '/document/fileCollection': '文档-portfolio文件收集',
  '/kp/seed': '部门公客池-列表',
  '/project/voteRecords': '项目-投票记录',
  '/systemSetting/manage/user': '设置-用户管理',
  '/document/fileExtraction': '文档-文件调取',
  '/meeting/createMeeting': '创建会议',
  '/systemSetting/manage/rolePower': '设置-用户管理-角色权限管理',
  '/finance/middlePage/list': '北冥-中间页列表',
  '/document/fileCollection/editMember': '文档-portfolio文件收集-项目人员维护',
  '/meeting/suggestParticipates': '会议-推荐参会会人员',
  '/finance/RMB/main': '北冥-人民币主基金',
  '/pdfview/knowledgeFile': '文件预览-knowledgeFile',
  '/finance/middlePage/detail/deal': '北冥-中间页详情-编辑交易',
  '/systemSetting/manage/projectQuality/createQuality': '设置-项目管理-品质表-创建',
  '/403': '403',
  '/systemSetting/manage/departmentRole': '设置-用户管理-部门角色管理',
  '/project/round': '项目-项目轮次',
  '/finance/middlePage/detail/exit': '北冥-中间页详情-编辑退出',
  '/finance/middlePage/historySlice': '北冥-财务交易数据中间页',
  '/meeting/detail': '会议-会议详情页',
  '/finance/USD/main': '北冥-人民币主基金',
  '/finance/fairvalueTable': '财务中间页-公允价值表(默认页面)',
  '/systemSetting/baseInfo': '设置-基础信息',
  '/document/share': '文档-共享云盘',
  '/data/report/legalDeliveryScale': '数据-数据报表-百川交割口径数据报表',
  '/project/meetingList': '项目-会议列表',
  '/legal/index': '百川',
  '/finance/fundManage/fundChart': '北冥-基金管理-Structure Chart',
  '/systemSetting/manage/documentType': '设置-项目管理-项目文档类型管理',
  '/kp': '部门公客池-列表',
  '/systemSetting/manage/sector': '设置-项目管理-行业领域管理',
  '/finance/USD/special': '北冥-人民币专项基金',
  '/bp/seed': '客户-BP投递',
  '/document': '文档',
  '/data/formList': '数据-列表',
  '/data': '数据',
  '/document/interview': '文档-专家',
  '/data/report/legalStartScale': '数据-百川启动口径数据报表',
  '/data/report/investPerformance': '数据-投资业绩数据报表',
  '/data/report/middlePage': '数据-财务项目交易数据报表',
  '/finance/RMB/special': '北冥-人民币专项基金',
  '/finance/RMB/feeder': '北冥-人民币feeder基金',
  '/finance/fundAuth/list': '北冥-基金授权',
  '/systemSetting/manage/projectMember': '设置-项目管理-项目人员维护',
  '/project/votePage': '项目-投票页面',
  '/systemSetting/manage/projectTags/company': '设置-项目管理-项目标签管理-公司标签',
  '/systemSetting/notice': '设置-运营管理-设置提醒',
  '/systemSetting/manage/projectProgress': '设置-项目管理-项目阶段管理',
  '/finance/USD/feeder': '北冥-美元feeder基金',
  '/systemSetting/manage/round': '设置-项目管理-项目轮次管理',
  '/systemSetting/manage/projectContribution': '设置-运营管理-交割项目贡献度管理',
  '/systemSetting/manage/financeProjectContribution': '设置-运营管理-北冥交易贡献表管理',
  '/systemSetting/manage/financeProjectVote': '设置-运营管理-北冥交易Vote管理',
  '/systemSetting/manage/projectTags/notes': '设置-项目管理-项目标签',
  '/systemSetting/manage/strategyTagRelation': '设置-项目管理-策略标签关系',
  '/systemSetting/manage/strategyTag': '设置-项目管理-策略标签',
  '/systemSetting/manage/menuPower': '设置-系统管理-菜单权限',
  '/data/report/USDIR': '数据-美元IR数据报表',
  '/systemSetting/manage/fundPermission': '设置-基金管理-基金权限',
  '/systemSetting/opLog': 'opLog',
  '/finance/fundManage/entitySearch': '北冥-基金管理-Structure Chart搜索',
  '/systemSetting/manage/projectContribution/createContribution': '设置-运营管理-交割项目贡献度管理-创建贡献表',
  '/data/report/voteRawReport': '数据-vote原始数据表',
  '/surface': '官网BP投递',
  '/surface/': '官网BP投递',
  '/data/report/voteOverviewReport': '数据-vote总览表',
  '/data/report/qualityReport': '数据-品质表报表',
  '/document/fileCollection/createTask': '文档-portfolio文件收集-创建作业',
  '/finance/RMB/investFund': '北冥-人民币投资基金'
};
